import { useSelector, useDispatch } from 'react-redux';
import FJModal from '../FJModal';
import FJUpgradeModal from './FJUpgradeModal';
import FJActionModal from '../../../redux/action/FJActionModal';
import useLocalStore from '../../../hooks/useLocalStore';
import useIsMobile from '../../../hooks/useIsMobile';
import FJMobileUpgradeModal from './FJMobileUpgradeModal/FJMobileUpgradeModal';
import FJActionCommon from '../../../redux/action/FJActionCommon';

const FJUpgradeModalContainer = () => {
    useLocalStore();
    const isMobile = useIsMobile();
    const dispatch = useDispatch();
    const upgradeModalData = useSelector(state => state.modals.upgradeModalData);
    const { display } = upgradeModalData;
    const onUpgrade = () => {
        dispatch(FJActionCommon.getCreditsAction());
    };
    const onClose = () => {
        dispatch(FJActionModal.hideUpgradeModalAction());
    };
    const render = () => {
        return isMobile ? (
            <FJModal zIndex={9} visible={display} borderRadius={20}>
                <FJMobileUpgradeModal onClose={onClose} onUpgrade={onUpgrade} />
            </FJModal>
        ) : (
            <FJModal visible={display}>
                <FJUpgradeModal onClose={onClose} onUpgrade={onUpgrade} />
            </FJModal>
        );
    };
    return <>{render()}</>;
};
export default FJUpgradeModalContainer;
